<template>
    <page-container>
        <el-breadcrumb slot="header"
                       separator="/"
                       v-if="!hideFrame">
            <el-breadcrumb-item :to="{ path: '/home' }"
                                replace>电子印章</el-breadcrumb-item>
            <el-breadcrumb-item :to="{ path: '/seal' }"
                                replace>印章管理</el-breadcrumb-item>
            <el-breadcrumb-item><a>印章详情</a></el-breadcrumb-item>
        </el-breadcrumb>

        <div class="seal-container">
            <div class="header-ctrl">
                <el-button class="grey-text small-font"
                           type="text"
                           @click="$router.back()">&lt; 返回上一页</el-button>
            </div>

            <div class="seal-content">
                <div class="seal-image transform-center">
                    <img :src="seal.seal_image"
                         alt="">
                </div>
                <div class="seal-info">
                    <h4 class="title">{{seal.seal_name}}</h4>
                    <div class="small-font info-content">
                        <p>
                            <span class="label tip">持有者：</span>
                            <span class="content-text">{{seal.possessor}}</span>
                        </p>
                        <p>
                            <span class="label tip">印章序列号：</span>
                            <span class="content-text">{{seal.seal_sn}}</span>
                        </p>
                        <p>
                            <span class="label tip">有效期起始时间：</span>
                            <span class="content-text">{{seal.not_before}}</span>
                        </p>
                        <p>
                            <span class="label tip">有效期结束时间：</span>
                            <span class="content-text">{{seal.not_after}}</span>
                        </p>
                    </div>
                </div>
                <div class="seal-status">
                    <svg class="icon"
                         style="font-size:70px;"
                         aria-hidden="true">
                        <use :xlink:href="seal.seal_status | statusFont"></use>
                    </svg>

                    <div class="ctrl-container">
                        <seal-control :seal="seal"
                                      @onFlesh="initData()"></seal-control>
                    </div>
                </div>
            </div>

            <p>操作日志：</p>
            <el-table :data="operateLogs"
                      border
                      class="logs-table">
                <el-table-column label="操作">
                    <template slot-scope="scope">
                        {{scope.row.operateType | operateType}}
                    </template>
                </el-table-column>
                <el-table-column label="操作时间"
                                 prop="operateTime"></el-table-column>
            </el-table>
        </div>
    </page-container>
</template>

<script>
import PageContainer from '../../components/container.vue';
import { keyType, keyUsage } from "../../components/ukey/keyModel";
import SealControl from "./childs/seal-control.vue";

export default {
    components: { PageContainer, SealControl },
    data () {
        return {
            timer: 0,
            seal: {},
            cert: {},
            writeSeal: {},
            operateLogs: [],
            ukeyDialog: false,
            existSeal: false
        };
    },
    mounted () {
        this.handleUkeyService();
        this.initData();
    },
    inject: ['app'],
    computed: {
        id () {
            return this.$route.params.id;
        },
        hideFrame () {
            return this.$route.query.hideFrame && this.$route.query.hideFrame !== 'false';
        }
    },
    methods: {
        async initData () {
            try {
                this.loading = this.$loading({
                    text: '加载中...'
                });
                await this.getSealDetail();
                await this.getOperateLogs();
            } catch (error) {
                console.log(error);
                if (error.message) {
                    this.$message.error(error.message);
                }
            } finally {
                this.loading && this.loading.close();
            }
        },

        /**
         * 获取操作记录
         */
        async getOperateLogs () {
            let resp = await this.axios({
                url: '/seal/operate/list',
                method: 'GET',
                params: { id: this.id }
            });
            if (resp.data.code === 0) {
                this.operateLogs = resp.data.result;
            }
        },

        /**
         * 检测ukey服务
         */
        handleUkeyService () {
            this.timer = setInterval(() => {
                this.app.ukey.listPlugin(keyType.K_SHCA_ASYMID_RSA).then(() => {
                    this.existDevice = true;
                    return this.app.ukey.getSeal(2);
                }).then((data) => {
                    if (data.result) {
                        this.writeSeal.struct = 'MII=';
                        this.existSeal = true;
                        clearInterval(this.timer);
                        return this.app.ukey.getCert(keyType.K_SHCA_ASYMID_RSA, keyUsage.K_SHCA_USAGE_SIGN);
                    }
                }).then((data) => {
                    this.cert = data.result;
                    let possessor = this.app.ukey.getCertDetailSync(this.cert, 17);
                    this.$set(this.seal, 'possessor', possessor);
                }).catch(err => {
                    console.log(err);
                    this.existSeal = false;
                });
            }, 5000);
        },

        /**
         * 获取印章详情
         */
        async getSealDetail () {

            let resp = await this.axios({
                url: '/seal/detail',
                method: 'GET',
                params: { sealId: this.id }
            });
            if (resp.data.code === 0) {
                this.seal = resp.data.result;
                this.$set(this.seal, 'seal_image', `data:image/png;base64,${resp.data.result.pic_data}`);
            }
        },
    },
    beforeDestroy () {
        clearInterval(this.timer);
    },
    filters: {
        operateType (type) {
            let types = {
                3: '吊销',
                4: '冻结',
                1: '解冻',
                7: '写入USBKey'
            };
            return types[type];
        }
    }
};
</script>

<style lang="less" scoped>
.seal-container {
    padding: 10px 20px;
}
.logs-table {
    margin: 8px 0 30px;
}
</style>
